// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:24:28

export default {
  "id": "squid-game-memory-card-match",
  "slug": "squid-game-memory-card-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a00888d72f744da685524e1706063c07-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a00888d72f744da685524e1706063c07/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Squid Game Memory Card Match",
      "description": "Step into the thrilling world of Squid Game Memory Card Match! Test your memory and focus as you uncover pairs of iconic Squid Game symbols and characters. Can you keep your cool under pressure and match all the cards before time runs out?\nChallenge yourself or compete with friends to see who can master the ultimate memory test. With Squid Game Memory Card Match, every flip brings you closer to victory or defeat – can you handle the pressure?",
      "instructions": "Mouse Click",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "boys",
        "girls",
        "matching",
        "memory",
        "squidgame"
      ]
    },
    "zh-CN": {
      "title": "鱿鱼游戏记忆卡匹配",
      "description": "踏入刺激的《鱿鱼游戏记忆卡匹配》世界！在揭开标志性《鱿鱼游戏》符号和角色的配对时，测试你的记忆力和专注力。你能保持冷静，在时间耗尽前匹配所有卡片吗？\n挑战自己或与朋友竞争，看谁能够掌握终极记忆测试。在《鱿鱼游戏记忆卡匹配》中，每一次翻转都让你更接近胜利或失败——你能承受压力吗？",
      "instructions": "鼠标点击",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "男孩们",
        "女孩们",
        "匹配",
        "记忆",
        "鱿鱼游戏"
      ]
    },
    "zh-TW": {
      "title": "章魚遊戲記憶卡配對",
      "description": "進入刺激的《章魚遊戲記憶卡配對》世界！檢驗你的記憶和專注力，當你揭開一系列經典的《章魚遊戲》符號和角色配對。你能夠在壓力下保持冷靜，在時間耗盡前完成所有卡片的配對嗎？\n挑戰自己或與朋友競賽，看看誰能夠掌握最終的記憶測試。在《章魚遊戲記憶卡配對》中，每一次翻牌都將你帶向勝利或失敗的邊緣——你能夠應付這種壓力嗎？",
      "instructions": "滑鼠點擊",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "男孩們",
        "女孩們",
        "配對",
        "記憶",
        "魚遊戲"
      ]
    },
    "zh-HK": {
      "title": "章魚遊戲記憶卡配對",
      "description": "踏入刺激的《鬥魚遊戲記憶卡配對》世界！檢驗你的記憶力和專注力，當你揭開一對象徵性的《鬥魚遊戲》符號和角色。你能夠在壓力下保持冷靜，在時間耗盡前配對所有卡片嗎？\n挑戰自己或與朋友競賽，看看誰能夠掌握最終的記憶測試。在《鬥魚遊戲記憶卡配對》中，每一次翻牌都將你帶近勝利或失敗，你能夠承受這種壓力嗎？",
      "instructions": "鼠標左鍵點擊",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "小夥伴",
        "小女孩",
        "配對",
        "記憶",
        "魚遊戲"
      ]
    },
    "ja": {
      "title": "イカゲーム メモリーカードマッチ",
      "description": "スクイッドゲーム メモリーカードマッチの刺激的な世界へと踏み込んでください！象徴的なスクイッドゲームのシンボルやキャラクターのペアを見つけることで、あなたの記憶と集中力を試してみましょう。プレッシャーの下でも冷静にして、カードをすべて一致させ時間が切れる前に勝利を手に入れることができますか？\n\n自分自身に挑戦したり、友人と競争したりして、誰が究極の記憶試験をマスターできるかを見極めましょう。スクイッドゲーム メモリーカードマッチであれば、どのターンも勝利または敗北に一歩近づくことになります。プレッシャーを乗り越えられるでしょうか？",
      "instructions": "マウスクリック",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "ボーイズ・ガールズ",
        "マッチング",
        "メモリ",
        "スクリューゲーム"
      ]
    },
    "ko": {
      "title": "오징어 게임 메모리 카드 매치",
      "description": "스퀴드 게임 메모리 카드 매치의 흥미진진한 세계로 들어가세요! 고전적인 스퀴드 게임 기호와 캐릭터를 맞추며 기억력과 집중력을 테스트하세요. 압박 속에서 자신을 지켜 모든 카드를 시간이 지나기 전에 맞추시了吗? 자신을 도전하거나 친구들과 경쟁하여 누가 최종 기억력 테스트를 마스터할 수 있을지 볼 수 있습니다. 스퀴드 게임 메모리 카드 매치에서는 모든 턴마다 승리나 패배에 가까워지지만, 그 압박을 견딜 수 있을까요?",
      "instructions": "마우스 클릭",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "아이들",
        "소녀들",
        "매칭",
        "기억",
        "치킨게임"
      ]
    },
    "fr": {
      "title": "Squid Game Match de Carte Mémoire",
      "description": "Entraînez-vous dans le monde captivant de Squid Game Memory Card Match ! Testez votre mémoire et votre concentration en découvrant des paires de symboles et de personnages emblématiques du Squid Game. Pouvez-vous rester calme sous la pression et trouver toutes les cartes avant que le temps ne s'écoule ?\nDéfiez-vous ou challengez vos amis pour voir qui peut maitriser le test de mémoire ultime. Avec Squid Game Memory Card Match, chaque retournement de carte vous rapproche de la victoire ou de la défaite – pouvez-vous gérer la pression ?",
      "instructions": "Clic souris",
      "genres": [
        "Casuel",
        "Puzzle"
      ],
      "tags": [
        "garçons",
        "filles",
        "correspondance",
        "mémoire",
        "Squid Game"
      ]
    }
  }
};
